import { Check } from "@mui/icons-material";
import { Grid, Paper, Table, TableBody, TableContainer, TableRow, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PriceDisplay } from "../../../../../components/common/PriceDisplay";
import {
    StyledTableCell,
    StyledTableHead,
} from "../../../../../components/table/BaseTable/BaseTable";
import { getDiscountedPricesForProduct } from "../../../../../utils";
import { calculateTotalPercentagePerProduct, calculateTotalPricePerProduct } from "../../utils";
import { roundToDecimalPlaces } from "../../../../../helpers/methods";

export const PaymentsSummary = (props) => {
    const { payments, products, productDiscounts } = props;
    const { t } = useTranslation();

    const productsMap = Object.fromEntries(products.map((product) => [product.id, product]));

    // TODO Old Soluion
    // const totalPercentagePerProduct =
    //     payments.length > 0
    //         ? calculateTotalPercentagePerProduct(payments)
    //         : Object.fromEntries(products.map((p) => [p.id, 0]));

    // const summaryData = Object.entries(totalPercentagePerProduct)
    //     .map(([productId, totalPercentage]) => {
    //         const product = productsMap[productId];
    //         if (!product) {
    //             return null;
    //         }
    //         const discount = productDiscounts?.[productId] ?? 0;
    //         const pricing = getDiscountedPricesForProduct(product, discount);
    //         const grossPrice = pricing.gross;
    //         const grossAmount = (grossPrice * totalPercentage) / 100;
    //         const remainingAmount = Math.abs(grossPrice - grossAmount);
    //         // Use epsilon comparison for floating-point precision issues
    //         const isSettled = Math.abs(remainingAmount) < 0.01;

    //         return {
    //             product,
    //             grossPrice,
    //             grossAmount,
    //             remainingAmount,
    //             isSettled,
    //         };
    //     })
    //     .filter((se) => se != null);


    const totalPricesPerProduct =
        payments.length > 0
            ? calculateTotalPricePerProduct(payments, products, productDiscounts)
            : Object.fromEntries(products.map((p) => [p.id, 0]));

    const summaryData = Object.entries(totalPricesPerProduct)
        .map(([productId, grossAmount]) => {
            const product = productsMap[productId];
            if (!product) {
                return null;
            }

            const discount = productDiscounts?.[productId] ?? 0;
            const pricing = getDiscountedPricesForProduct(product, discount);
            const grossPrice = roundToDecimalPlaces(pricing.gross, 2)
            const remainingAmount = grossPrice - roundToDecimalPlaces(grossAmount, 2)
            const isSettled = remainingAmount === 0

            return {
                product,
                grossPrice,
                grossAmount,
                remainingAmount,
                isSettled,
            };
        })
        .filter((se) => se != null);

    const areAllSettled = summaryData.every((se) => se.isSettled);

    return (
        <Paper
            sx={{
                p: 2,
                mt: 2,
                border: 2,
                borderColor: areAllSettled ? "success.light" : "warning.light",
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography>{t("agreements.PaymentsSummary.summary")}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer>
                        <Table>
                            <StyledTableHead>
                                <TableRow>
                                    <StyledTableCell>
                                        {t("agreements.PaymentsSummary.product")}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {t("agreements.PaymentsSummary.grossPrice")}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {t("agreements.PaymentsSummary.remaining")}
                                    </StyledTableCell>
                                    <StyledTableCell sx={{ width: 48 }} />
                                </TableRow>
                            </StyledTableHead>
                            <TableBody>
                                {summaryData.map((se) => (
                                    <TableRow key={se.product.id} sx={{ minHeight: 48 }}>
                                        <StyledTableCell>{se.product.name_full}</StyledTableCell>
                                        <StyledTableCell>
                                            <PriceDisplay price={se.grossAmount} />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <PriceDisplay price={se.remainingAmount}/>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {se.isSettled ? (
                                                <Check sx={{ color: "success.light" }} />
                                            ) : null}
                                        </StyledTableCell>
                                    </TableRow>
                                ))}
                                <TableRow key={"summary"} sx={{ minHeight: 48 }}>
                                        <StyledTableCell>            
                                            <Typography fontWeight={"bold"}>
                                                {t("agreements.AgreementProductsTable.total")}
                                            </Typography>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <PriceDisplay price={summaryData.reduce((currvalue, product)=>currvalue + product.grossAmount, 0)} style={{fontWeight: "bold"}}/>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <PriceDisplay price={summaryData.reduce((currvalue, product)=>currvalue + product.remainingAmount, 0)} style={{fontWeight: "bold"}}/>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {summaryData.every(se=>se.isSettled) ? <Check sx={{ color: "success.light" }} /> : null }
                                        </StyledTableCell>
                                    </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Paper>
    );
};
